import React from 'react'
import "./DPainting.css"



import one from "./3d 1.jpg"
import two from "./3d 2.jpg"
import three from "./3d 3.jpg"
import four from "./3d 4.jpg"
import five from "./3d 5.jpg"
import six from "./3d 6.jpg"
import seven from "./3d 7.jpg"
import eight from "./3d 8.jpg"
import nine from "./3d 9.jpg"
import ten from "./3d 10.jpg"
import eleven from "./3d 11.jpg"
import twelve from "./3d 12.jpg"
import thirt from "./3d 13.jpg"

const DPainting = () => {
  return (
    <div className='hello'>
        <div className='painting'>
        <img src={one} alt='this is an waka'/>
        <img src={five} alt='this is an waka'/>
        <img src={three} alt='this is an waka'/> 
        </div>
       <div className='painting'>
        <img src={four} alt='this is an waka'/>      
        <img src={six} alt='this is an waka'/>      
        <img src={eight} alt='this is an waka'/>
       </div> 
        <div className='painting'>
        <img src={seven} alt='this is an waka'/>      
        <img src={ten} alt='this is an waka'/>
        <img src={nine} alt='this is an waka'/>
        </div>
       <div className='painting'>
       <img src={eleven} alt='this is an waka'/>
        <img src={twelve} alt='this is an waka'/>
         <img src={thirt} alt='this is an waka'/>
       </div>
        <div className='painting'>
        <img src={two} alt='this is an waka'/>
        </div>
    </div>
  )
}

export default DPainting

